$ = require('jquery')

require('../class/wNumb')
noUiSlider = require('../class/nouislider')

module.exports =
	init: (payload) ->
		{$target} = payload

		$target.find('.multislider').each(->
			$this = $(this)
			$from = $this.find('.from')
			$to = $this.find('.to')
			$fromText = $this.find('.from-text span')
			$toText = $this.find('.to-text span')
			slider = $this.find('.slider').get(0)

			noUiSlider
				.create(slider,
					start: [ $from.val(), $to.val() ]
					step: 10
					connect: true
					range:
						'min': $this.data('min')
						'max': $this.data('max')
					format: wNumb(
						decimals: 0
						thousand: ' '
					)
				)

			slider.noUiSlider.on('set', (values, handle, unencoded, tap, positions) ->
				$from.val(values[0])
				$to.val(values[1])
				$fromText.text(values[0])
				$toText.text(values[1])
				$to.trigger('change')
			)

			slider.noUiSlider.on('slide', (values, handle, unencoded, tap, positions) ->
				$fromText.text(values[0])
				$toText.text(values[1])
			)

			$this.data('slider', slider)

			return
		)

		return



// WEBPACK FOOTER //
// ./src/js/components/multislider.coffee